import { useState } from "react";
import "./Partner.css";

const partnerLogos = [
  "Acintyo_5_11zon.webp",
  "DA_7_11zon.webp", 
  "Enorvision_1_11zon.webp",
  "Gods Club_6_11zon.webp",
  "HBF_11zon.webp",
  "Indus Expert_2_11zon.webp",
  "Taiiki_4_11zon.webp"
];

export const Partner = () => {
  const [paused, setPaused] = useState(false);

  return (
    <section className="partner-section">
      <div className="partner-container">
        {/* Header */}
         <header className="partner-header">
          <p className="partner-subtitle">
            TRUSTED PARTNERS
          </p>
          <h2 className="partner-title">
            Building Success Together
          </h2>
          <p className="partner-description">
            At AQT Direct, we believe that great achievements happen through collaboration. 
            We're proud to partner with visionary companies across sectors, combining our 
            private equity expertise with their industry knowledge to create exceptional 
            value and drive meaningful growth for all stakeholders.
          </p>
        </header>

        {/* Marquee Logos */}
        <div className="marquee-container">
          <div
            className="marquee-content"
            style={{ animationPlayState: paused ? "paused" : "running" }}
          >
            {[...partnerLogos, ...partnerLogos].map((logo, index) => (
              <div
                key={index}
                className="logo-container"
                onMouseEnter={() => setPaused(true)}
                onMouseLeave={() => setPaused(false)}
              >
                <img
                  src={require(`./${logo}`)}
                  alt={`partner logo ${index + 1}`}
                  className="logo-image"
                />
              </div>
            ))}
          </div>
        </div>

        {/* Gradient Overlay */}
        <div className="gradient-overlay" />
      </div>
    </section>
  );
};